import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import authService from '../../api-authorization/AuthorizeService';
import { Row, Col, Button, Form, FormGroup, Label, Input, FormText, Badge } from 'reactstrap';
import { PerkDetailsForm } from './PerkDetailsForm';
import { DataDraftAlertMessage } from '../alert/DataDraftAlertMessage';

import PerkDetailsHelp from './PerkDetailsHelp';
import { PerkStory } from './PerkStory';
import { HelpProvider } from '../../common/HelpProvider';
import { PerkInProducts } from './PerkInProducts';


export class PerkDetails extends Component {
    static displayName = PerkDetails.name;

    constructor(props) {
        super(props);
        this.state = {
            designerId: props.match.params.designerId,
            perkId: props.match.params.perkId,
            data: null,
            loading: true,
            error: null
        };
        this.populateData = this.populateData.bind(this);
        this.onSubmitToReview = this.onSubmitToReview.bind(this);
        this.onRevertBackData = this.onRevertBackData.bind(this);
        this.setError = this.setError.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.error !== prevState.error &&
            this.state.error && this.state.error.length > 0) {
            this.scrollPageToTop();
        }
    }

    setError(error) {
        this.setState({
            error: error
        })
    }

    scrollPageToTop() {
        console.log('scroll up');
        setTimeout(function () {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 500);
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="d-flex justify-content-center m-5 p-5">
                    <div className="spinner-border m-5" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>);
        }

        const { data, designerId, perkId } = this.state;

        if (!data) {
            return <Redirect to={`/manage/${designerId}/perks`} />
        }

        return (
            <HelpProvider>
                <Row className="mt-3 mb-5">
                    <Col xs="8">
                        <h1><span className="dep-title">PERK</span><span>{data.title}</span></h1>
                        <p>Edit the details of your perk page.</p>
                        <DataDraftAlertMessage
                            onSubmitToReview={this.onSubmitToReview}
                            onRevertBackData={this.onRevertBackData}
                            dataDraftStatus={data.dataDraftStatus}
                            allowSubmitToReview={data.allowSubmitToReview}
                        />
                        <div className="mt-3 mb-5">
                            <PerkDetailsForm
                                data={data}
                                designerId={designerId}
                                perkId={perkId}
                                scrollPageToTop={this.scrollPageToTop}
                                setError={this.setError}
                                updateData={this.populateData}
                            />
                        </div>
                        <div className="mt-3 mb-5">
                            <PerkInProducts
                                data={data}
                                designerId={designerId}
                                perkId={perkId}
                                scrollPageToTop={this.scrollPageToTop}
                                setError={this.setError}
                                updateData={this.populateData}
                            />
                        </div>
                        <div className="mt-3 mb-5">
                            <PerkStory storySetting={data.storySetting}
                                designerId={designerId}
                                perkId={perkId}
                            />
                        </div>
                        <div className="mt-3 mb-5">
                            <div className="p-4 text-light bg-dark rounded box-shadow">
                                <h5>Perk settings</h5>
                                <p></p>
                                <div className="mt-3">
                                    {/*<Button color="danger" size="sm" disabled={true} className="mr-2">Delete perk</Button>*/}
                                    <Button color="danger" size="sm" disabled={true}>Disable perk</Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs="4">
                        <PerkDetailsHelp />
                    </Col>
                </Row>
            </HelpProvider>
        );
    }

    async populateData(done) {
        const token = await authService.getAccessToken();
        const response = await fetch(`/api/brand/${this.state.designerId}/perks/details/${this.state.perkId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        console.log(data);
        this.setState({
            data: data,
            loading: false
        });
        if (done) done();
    }
     


    async onSubmitToReview(event) {
        event.preventDefault();

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const response = await fetch(`/api/brand/${this.state.designerId}/perks/${this.state.perkId}/edit/submittoreview`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Authorization': `Bearer ${token}`
            },
        });

        const newDta = await response.json();
        console.log(newDta);

        if (newDta && newDta.result) {
            this.setState({
                data: newDta.perk,
                loading: false
            });
            this.scrollPageToTop();
        } else {
            this.setError(`Error`);
        }
    }

    async onRevertBackData(event) {
        event.preventDefault();

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const response = await fetch(`/api/brand/${this.state.designerId}/perks/${this.state.perkId}/edit/revertback`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Authorization': `Bearer ${token}`
            },
        });

        const newDta = await response.json();
        console.log(newDta);

        if (newDta && newDta.result) {
            this.setState({
                data: newDta.perk,
                loading: false
            });
            this.scrollPageToTop();
        } else {
            this.setError(`Error`);
        }
    }
}
